export const DEBTS_RECIEVED = "DEBTS_RECIEVED"
export const DEBTS_ASOF_RECIEVED = "DEBTS_ASOF_RECIEVED"
export const DEBT_SAVED = "DEBT_SAVED"
export const DEBT_DELETED = "DEBT_DELETED"
export const DEBT_UNLOADED = "DEBT_UNLOADED"
